export default "__VITE_ASSET__81178f8e__"